<div class="force-change-password-popup" [class.password-changed]="isPasswordChanged">
  @if (!isPasswordChanged) {
    <img class="warning_icon" src="../../../../assets/svg/warning.svg" />
    <h3 class="title">{{ "FORCE_CHANGE_PASSWORD.TITLE" | translate }}</h3>
    <span class="description">{{ "FORCE_CHANGE_PASSWORD.DESCRIPTION" | translate }}</span>
    <div class="form-group">
      <app-password-input
        [password]="password"
        (passwordChange)="handleSetPassword($event)"
        [(isValidated)]="isPasswordValidated"
        [isBusiness]="userData.clientType === userType.business"
        [isTaxAdviser]="userData.isTaxAdviser"
        [isSubaccount]="userData.isSubaccount"
        [isMaster]="userData.isMasterAccount"
        [errors]="errors"
        >
      </app-password-input>
    </div>
    <div class="button-section">
      @if (allowCloseModal) {
        <button class="close-modal" (click)="handleSkipChangePassword()">{{
          "FORCE_CHANGE_PASSWORD.CLOSE_MODAL_TEXT" | translate
        }}</button>
      }
      <app-button-fill-primary
        [class]="'change-button'"
        (clickEmitter)="handleChangePassword()"
        [isLoading]="isLoading"
        >
        {{ "FORCE_CHANGE_PASSWORD.BUTTON_TEXT" | translate }}
      </app-button-fill-primary>
    </div>
  }

  @if (isPasswordChanged) {
    <img class="warning_icon" src="../../../../assets/svg/success.svg" />
    <h3 class="title">{{ "FORCE_CHANGE_PASSWORD.SUCCESS_MESSAGE_TITLE" | translate }}</h3>
    <span class="description">{{ "FORCE_CHANGE_PASSWORD.SUCCESS_MESSAGE" | translate }}</span>
    <div class="button-section">
      <app-button-fill-primary [class]="'change-button'" (clickEmitter)="closeDialog()">
        {{ "FORCE_CHANGE_PASSWORD.BACK_TO_DASHBOARD" | translate }}
      </app-button-fill-primary>
    </div>
  }
</div>
